var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"ctx-item",on:{"click":_vm.handleClick,"mouseover":_vm.handleOver,"mouseout":_vm.handleOut}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }